import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["focusField"];

  show(popupName) {
    document
      .querySelector(`[data-popup="${popupName}"]`)
      .classList.remove("hidden");
    if (this.hasFocusFieldTarget) this.focusFieldTarget.focus();
  }

  open(event) {
    const popupName = event.target.getAttribute("data-popup-name");

    this.show(popupName);
  }

  close(event) {
    const popupName = event.target.getAttribute("data-popup-name");

    document
      .querySelector(`[data-popup="${popupName}"]`)
      .classList.add("hidden");
  }

  closeOnSuccess(event) {
    if (!event.detail.success) return;

    this.close(event);
  }

  load(event) {
    event.preventDefault();

    let modalSize = event.target.closest("a").getAttribute("data-modal-size");
    let jsUrl = event.target.closest("a").href;

    if (jsUrl.indexOf("?") > -1) {
      jsUrl = jsUrl.replace("?", ".js?");
    } else {
      jsUrl += ".js";
    }

    fetch(jsUrl)
      .then((response) => {
        if (response.status === 401 && response.statusText === "Unauthorized") {
          window.location.reload();
          return Promise.reject();
        } else {
          return response.text();
        }
      })
      .then((html) => {
        // this.show('loaded-modal', html);\
        document.querySelector("#popup-body-loaded-modal").innerHTML = html;

        if (window.ReactRailsUJS) window.ReactRailsUJS.mountComponents();

        if (modalSize === "full-screen") {
          document
            .querySelector("#popup-container-loaded-modal")
            .classList.remove("xl:w-1/2");
        } else {
          document
            .querySelector("#popup-container-loaded-modal")
            .classList.add("xl:w-1/2");
        }

        this.show("loaded-modal");
      });
  }
}
